import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Loader from "../../components/ui/Loader";
import { User } from "@cabukaka/types";
import { authService } from "@cabukaka/services";
import { useAuth } from "@cabukaka/hooks";

export default function Redirect() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const { setUser } = useAuth()

  const navigate = useNavigate();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        if (!token) {
          navigate("/login");
          return;
        }

        const currentUser: User | null = await authService.getUserProfile(token);

        if (currentUser) {
          setUser(currentUser)
          navigate(`/${currentUser.role}/overview`);
        } else {
          navigate("/login");
        }
      } catch (err) {
        navigate("/login");


      }
    };

    fetchUser();
  }, [token, navigate]);

  return <Loader />;
}
